import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetLensCuttingMachineIntegrationFileByOrderOutput } from './GetLensCuttingMachineIntegrationFileByOrderOutput';

export class GetLensCuttingMachineIntegrationFileByOrderService extends HttpServiceBase {

  handle = (orderId: number): Promise<Result<GetLensCuttingMachineIntegrationFileByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetLensCuttingMachineIntegrationFileByOrderOutput>>(`${this.baseUrlSislogApi}/v2/lens-cutting-cachine-integration/integration-file-list-by-order/${orderId}`);
    return promise;
  }
}